"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _form = _interopRequireDefault(require("./form"));
var Icon = function Icon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#939393",
    d: "M7.5 12A2.25 2.25 0 1 1 3 12a2.25 2.25 0 0 1 4.5 0zm6.75 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0zM21 12a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#5C5C5C",
    d: "M14.857 5.76a.466.466 0 0 0-.002-.66l-.806-.801H8.094a.938.938 0 0 0-.812.469L5.461 7.922a.469.469 0 0 0 .406.703h1.245a.938.938 0 0 0 .812-.469l.82-1.42a.375.375 0 0 1 .324-.187h4.998l.79-.788zM9.913 17.452h5.017a.375.375 0 0 0 .325-.188l.82-1.42a.938.938 0 0 1 .812-.469h1.245c.36 0 .586.39.406.703l-1.822 3.155a.938.938 0 0 1-.812.469H9.951l-.821-.814a.47.47 0 0 1 .002-.664l.78-.772z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#2E2E2E",
    d: "M9.138 18.889a.469.469 0 0 1 0-.663l2.05-2.05a.469.469 0 0 0-.33-.801H9.194a.938.938 0 0 0-.663.275l-2.244 2.244a.937.937 0 0 0 0 1.326l2.244 2.244a.938.938 0 0 0 .663.275h1.662a.469.469 0 0 0 .332-.8l-2.05-2.05zM14.85 5.1a.469.469 0 0 1 0 .663l-2.05 2.05a.469.469 0 0 0 .332.801h1.662a.938.938 0 0 0 .663-.275L17.7 6.095a.938.938 0 0 0 0-1.326l-2.244-2.244a.937.937 0 0 0-.663-.275h-1.662a.469.469 0 0 0-.332.8l2.05 2.05z"
  }));
};
Icon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
var config = {
  angConfiguration: {
    typeURL: 'http://anypoint.com/vocabs/digital-repository#RPAActivityTemplateAsset',
    assetType: 'RPAActivityTemplate'
  },
  owner: {
    gusTeam: 'MS RPA Platform APIs',
    gusTeamLink: 'https://gus.lightning.force.com/lightning/r/ADM_Scrum_Team__c/a00EE00000C2bkYYAR/view'
  },
  name: 'RPA Activity Template',
  pluralName: 'RPA Activity Templates',
  featureFlag: 'rpa-templates-enabled',
  publication: {
    uiForm: _form.default,
    inferredBy: [{
      classifiers: ['rpa-activity-template']
    }],
    files: [{
      id: 'rpa-activity-template-binary',
      classifier: 'rpa-activity-template',
      packaging: 'calw',
      mainFileLocationProperty: 'mainFile'
    }],
    minimumInputSets: [{
      files: ['rpa-activity-template-binary']
    }]
  },
  portal: {
    icon: Icon,
    color: '#0176d3',
    files: [{
      fileId: 'rpa-activity-template-binary',
      label: 'RPA Activity Template'
    }]
  }
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map